/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Zoom to Fit Icon component.
 */
export const ZoomToFitIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='ZoomToFitIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox="0 0 24 24" fill="none">
        <rect x="5" y="5" width="3.23077" height="3.23077" rx="1.61538" fill={iconColor}/>
        <rect x="5" y="10.3845" width="3.23077" height="3.23077" rx="1.61538" fill={iconColor}/>
        <rect x="5" y="15.7693" width="3.23077" height="3.23077" rx="1.61538" fill={iconColor}/>
        <rect x="10.3848" y="5" width="3.23077" height="3.23077" rx="1.61538" fill={iconColor}/>
        <rect x="15.769" y="5" width="3.23077" height="3.23077" rx="1.61538" fill={iconColor}/>
        <rect x="10.3848" y="10.3845" width="3.23077" height="3.23077" rx="1.61538" fill={iconColor}/>
        <rect x="15.769" y="10.3845" width="3.23077" height="3.23077" rx="1.61538" fill={iconColor}/>
        <rect x="10.3848" y="15.7693" width="3.23077" height="3.23077" rx="1.61538" fill={iconColor}/>
        <rect x="15.769" y="15.7693" width="3.23077" height="3.23077" rx="1.61538" fill={iconColor}/>
        <path d="M17.5 1H21C22.1046 1 23 1.89543 23 3V6.5M6.5 1C5.44374 1 4.09626 1 2.99942 1C1.89485 1 1 1.89543 1 3V6.5M23 17.5V21C23 22.1046 22.1046 23 21 23H17.5M1 17.5V21C1 22.1046 1.89543 23 3 23H6.5" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    )} />
  );
};
